<template>
    <div class="rsvm--check-main container">

        <div v-if="!InputsObject.IF.rvsmChecks">
            <P>Rvsm Checks data couldn't get...</P>
        </div>

        <div v-for="(rvsm,index) in InputsObject.IF.rvsmChecks" :key="index">
            <div class="box">
                <div class="title is-size-5"><p>{{(RVSMTypes.find(x=>x.value==index)).text}}</p></div>
                <div class="field is-horizontal">
                    <div class="field-label"><label class="label">Time</label></div>
                    <div class="field-body">
                        <div class="field is-expanded">
                            <div class="field has-addons">
                                <p class="control is-expanded">
                                    <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="rvsm.time" v-model="rvsm.time" disabled/>
                                </p>
                                <p class="control">
                                <span>
                                <a class="button"><i class="fa fa-clock"></i></a>
                                </span>
                                </p>
                            </div>
                        </div>
                    </div>
            </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">FL</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.fl" v-model="rvsm.fl" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Altimeter Left</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.altimeterLeft" v-model="rvsm.altimeterLeft" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Altimeter Right</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.altimeterRight" v-model="rvsm.altimeterRight" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Altimeter STBY</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.altimeterSTBY" v-model="rvsm.altimeterSTBY" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">E/O FL</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.eoFL" v-model="rvsm.eoFL" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">E/O Speed</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="ft" v-if="rvsm.eoSpeed" v-model="rvsm.eoSpeed" disabled>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">E/O N1</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" type="text" placeholder="-" v-if="rvsm.eoN1" v-model="rvsm.eoN1" disabled>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import Datepicker from "vue-bulma-datepicker";
    import {loadingMixin} from "../../../utils/mixins";
    import {mapState} from "vuex";

    export default {
        name: "RVSMCheck",
        mixins: [loadingMixin],
        data() {
            return {
                firstFormVisible: true,
                secondFormVisible: false,
                thirdFormVisible: false,
                rvsmChecklist:[],
                RVSMTypes :[
                    {text: 'First', value:0},
                    {text: 'Second', value:1},
                    {text: 'Third', value:2},
                    {text: 'Fourth', value:3},
                    {text: 'Fifth', value:4},
                    {text: 'Sixth', value:5},
                    {text: 'Seventh', value:6},
                    {text: 'Eighth', value:7},
                    {text: 'Ninth', value:8},
                    {text: 'Tenth', value:9},
                ],
            }
        },

        computed : {
            ...mapState("ipadmain",[ "selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),
        },

        components: {
            Datepicker,
        },

        methods: {

        }

    }
</script>

<style scoped>
    .rsvm--check-main {
    }

    .content {
        transition-delay: 1s;
        transition: width 3s;
    }

    .icon {
        cursor: pointer;
    }

    .fa-3x {
        font-size: 3em;
    }

    .fa-3x:hover {
        font-size: 4em;
        transition: all .1s ease-in-out;
    }

    .level {
        padding: 10px;
        background-color: #b5b5b53d;
    }

    .field, input {
        width: 300px;
    }

    .field-label {
        width: 200px;
    }

    .label {
        width: 200px;
    }
</style>
